import { TableContainerProps } from '@material-ui/core';
import { TableContainer } from '@material-ui/core';
import React from 'react';
import { TableLinearLoading } from './TableLinearLoading';
import { TableNoResult, TableNoResultProps } from './TableNoResult';

export type DataTableProps = TableNoResultProps & {
    isLoading: boolean
    tableContainerProps?: TableContainerProps
}

export function DataTable ({ isLoading, tableContainerProps, ...props }: DataTableProps) {
    return (
        <TableContainer {...tableContainerProps}>
            <TableLinearLoading isLoading={isLoading} />
            <TableNoResult {...props} />
        </TableContainer>
    )
}